import { RichTextNodeType } from "@prismicio/types-internal/lib/customtypes"
import type { Editor } from "@tiptap/core"

import type { MediaAssetOrExternalImage } from "../../../../core/MediaLibrary/hooks/mediaLibraryData"
import { MediaDialog } from "../../../ImageField/MediaDialog"
import { createRunCommandsFn } from "../../models/MenuItems"

interface SetMediaLinkModalProps {
  open: boolean
  setOpen: (open: boolean) => void
  editor: Editor
}

export function SetMediaLinkModal(props: SetMediaLinkModalProps) {
  const { open } = props
  const { onOpenChange, onMediaSelected } = useLinkModal(props)

  return (
    <MediaDialog
      open={open}
      onOpenChange={onOpenChange}
      onMediaSelected={onMediaSelected}
      assetType="all"
    />
  )
}

function useLinkModal(props: SetMediaLinkModalProps) {
  const { editor, setOpen } = props

  function onMediaSelected(media: MediaAssetOrExternalImage) {
    const setLink = createRunCommandsFn((commands) =>
      commands
        .extendMarkRange(RichTextNodeType.hyperlink)
        .setMediaLink({ media }),
    )
    setLink(editor)
    setOpen(false)
  }

  return {
    onMediaSelected,
    onOpenChange: setOpen,
  }
}
